module.exports = __webpack_public_path__ + "img/predicciones_mobil.32927b90.png";